import { render } from "./PassReset.vue?vue&type=template&id=4448fb85&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"

import "./PassReset.vue?vue&type=style&index=0&id=4448fb85&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4448fb85"]])

export default __exports__